import { memo, useEffect } from 'react'

import { Link, useNavigate } from 'react-router-dom'

import { LocalStorageKeys } from '@/consts/localStorage.ts'
import { useAccount } from '@/modules/accounts/hooks/useAccounts'
import { LoginForm } from '@/modules/accounts/ui/AccountLoginForm'
import { AppRoutes } from '@/utils/constants'
import { classNames } from '@/utils/helpers'
import { useIsDarkTheme } from '@/utils/useTheme'

const _LoginPage = () => {
  const { isLoggedIn, login } = useAccount()

  const navigate = useNavigate()

  const isDarkMode = useIsDarkTheme()

  // Redirect user on login
  useEffect(() => {
    if (isLoggedIn) {
      let redirectUrl = AppRoutes.Overview.asUrl()
      const redirectUrlFromStorage = sessionStorage.getItem(
        LocalStorageKeys.REDIRECT_AFTER_LOGIN,
      )

      if (redirectUrlFromStorage) {
        sessionStorage.removeItem(LocalStorageKeys.REDIRECT_AFTER_LOGIN)
        redirectUrl = redirectUrlFromStorage
      }

      navigate(redirectUrl)
    }
  }, [isLoggedIn, navigate])

  return (
    <div
      className={classNames(
        "grid h-screen w-screen place-items-center bg-[url('/login-background.webp')] bg-cover bg-no-repeat",
        {
          "bg-[url('/login-background-dark.png')]": isDarkMode,
        },
      )}
    >
      <div className=" w-full max-w-xl rounded-xl bg-card px-6 py-9 shadow-2xl">
        <LoginForm loginMutation={login} />

        <div className="flex items-center justify-center gap-1 text-sm font-normal text-text-sub sm:px-14">
          <p>Don’t have an account? </p>
          <Link
            to="https://www.creatorhero.com/"
            className="text-sm text-primary-500 underline"
            target="_blank"
          >
            Get CreatorHero
          </Link>
        </div>

        <div className="mt-1 flex items-center justify-center gap-1 text-sm font-normal text-text-sub sm:px-14">
          <p>Forgot your password? </p>
          <Link
            to={AppRoutes.Auth.ResetPassword.asUrl()}
            className="text-sm text-primary-500 underline"
          >
            Reset Password
          </Link>
        </div>
      </div>
    </div>
  )
}

export const LoginView = memo(_LoginPage)
